import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import {NetworkFilterService} from '../../../network/utils/filters/network/network-filter.service';

@Injectable({
  providedIn: 'root'
})
export class PeerConnectionFilterService {

  constructor() { }

  public static mapFilter(pCons: any, searchObject: any): any {

    const searchableFields = ['nodes', 'pCons', 'connections', 'voipPeers', 'administrative state', 'operative state', 'name'];

    let filteredPCons = _.cloneDeep(pCons);
    const searchObjectCopy = NetworkFilterService.formatSearchObject(searchObject);

    const filterByName = (pConList, nameObject) => {
      if (nameObject && nameObject.value) {
        pConList = pConList.filter((pCon) => {
          return pCon.name.toLowerCase().indexOf(nameObject.value.toLowerCase()) > -1;
        });
      }
      return pConList;
    };

    const filterByAdminState = (pConList, adminStateObject) => {
      if (adminStateObject && adminStateObject.value) {
        pConList = pConList.filter((pCon) => {
          return _.isEqual(pCon.adminState.toLowerCase(), adminStateObject.value.toLowerCase());
        });
      }
      return pConList;
    };


    const filterByOperState = (pConList, operStateObject) => {
      if (operStateObject && operStateObject.value) {
        pConList = pConList.filter((pCon) => {
          if (!_.isArray(operStateObject.value)) {
            return  operStateObject.value.toLowerCase() ===  pCon.operState.toLowerCase();
          }
          return operStateObject.value.find((state) => {
            return  state.toLowerCase() === pCon.operState.toLowerCase();
          });
        });
      }
      return pConList;
    };

    const markfilteredPCons = (pConList, filtered) => {
      pConList = pConList.map((pCon) => {
        pCon.filtered = isElementFiltered(filtered, pCon);
        return pCon;
      });
      return pConList;
    };

    const isElementFiltered = (array, searchedObject) => {
      return !!array.find((arrayItem) => {
        return arrayItem.id === searchedObject.id;
      });
    };

    if (!searchObjectCopy) {
      return pCons;
    }

    if (searchObjectCopy.freeText) {
      searchObjectCopy.name = {value: searchObjectCopy.freeText};
      filteredPCons = filterByName(filteredPCons, searchObjectCopy.name);
      return markfilteredPCons(pCons, filteredPCons);
    }

    if (!searchObjectCopy.pCons) {
      return markfilteredPCons(pCons, []);
    }

    if (NetworkFilterService.haveNonSearchableFields(searchObjectCopy, searchableFields)) {
      return markfilteredPCons(pCons, []);
    }

    if (!searchObjectCopy.pCons.value || searchObjectCopy.pCons.value === 'no') {
      return markfilteredPCons(pCons, []);
    }

    filteredPCons = filterByName(filteredPCons, searchObjectCopy.name);
    filteredPCons = filterByAdminState(filteredPCons, searchObjectCopy['administrative state']);
    filteredPCons = filterByOperState(filteredPCons, searchObjectCopy['operative state']);
    return markfilteredPCons(pCons, filteredPCons);
  }

  public static testRouteFilter(pCons: any, testRoutePath: any): any {
    const pConsToFilter = [];
    pConsToFilter.push(testRoutePath.srcPeerConnection);
    pConsToFilter.push(testRoutePath.destPeerConnection);

    pCons = pCons.map((pCon) => {
      if (pConsToFilter.filter((pConToFilter) => {
        return pConToFilter === pCon.id; }).length > 0) {
        pCon.testRouteFilter = true;
      }
      return pCon;
    });
    return pCons;
  }
}
